import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doRefreshToken: UseCase<AuthRepository, 'refreshToken'> = repository => {
  return async () => {
    return await repository.refreshToken()
  }
}
